import { createContext, PropsWithChildren, useContext, useState } from 'react';
import useWordlistWords from '../_hooks/useWordlistWords';
import WordlistContext from './WordlistContext';

export const WordlistViewMode = {
  LIST: 'list',
  FOCUS: 'focus',
} as const;

type ViewMode = typeof WordlistViewMode[keyof typeof WordlistViewMode];

type WordlistViewModeContextValue = {
  viewMode: ViewMode;
  setViewMode: (viewMode: ViewMode) => void;
};

const WordlistViewModeContext = createContext<WordlistViewModeContextValue>({
  viewMode: WordlistViewMode.LIST,
  setViewMode: () => {},
});

export default WordlistViewModeContext;

export function WordlistViewModeContextProvider({ children }: PropsWithChildren) {
  const { setSelectedWord, setCardsExpanded } = useContext(WordlistContext);
  const [viewMode, setViewMode] = useState<ViewMode>(WordlistViewMode.LIST);

  const words = useWordlistWords();

  const handleViewModeChange = (viewMode: ViewMode) => {
    setViewMode(viewMode);

    setCardsExpanded(false);

    if (words?.length) {
      setSelectedWord(words[0]);
    }
  };

  return (
    <WordlistViewModeContext.Provider
      value={{
        viewMode,
        setViewMode: handleViewModeChange,
      }}
    >
      {children}
    </WordlistViewModeContext.Provider>
  );
}
